import { alpha } from '@mui/material/styles';

/** Soft badge / pill background + foreground from a palette semantic color. */
export const semanticTone = (theme, colorKey = 'default') => {
  if (colorKey === 'default') {
    return {
      bg: theme.palette.action.selected,
      fg: theme.palette.text.secondary,
    };
  }

  const paletteColor = theme.palette[colorKey];
  if (!paletteColor?.main) {
    return {
      bg: theme.palette.action.subtleLight,
      fg: theme.palette.text.secondary,
    };
  }

  const isDark = theme.palette.mode === 'dark';
  return {
    bg: alpha(paletteColor.main, isDark ? 0.18 : 0.12),
    fg: isDark ? paletteColor.light || paletteColor.main : paletteColor.dark || paletteColor.main,
  };
};

export const httpMethodTone = (theme, method) => {
  const colorKey =
    {
      GET: 'success',
      POST: 'primary',
      PUT: 'warning',
      PATCH: 'info',
      DELETE: 'error',
    }[String(method || '').toUpperCase()] || 'primary';

  return semanticTone(theme, colorKey);
};

export const variableNamespaceTone = (theme, namespaceId) => {
  const colorKey =
    {
      args: 'primary',
      context: 'warning',
      user: 'success',
      secrets: 'error',
    }[namespaceId] || 'default';

  return semanticTone(theme, colorKey);
};

export const invertedActionButtonStyles = theme => ({
  backgroundColor: theme.palette.text.primary,
  color: theme.palette.background.paper,
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: theme.palette.text.secondary,
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    backgroundColor: theme.palette.action.subtleLight,
    color: theme.palette.text.disabled,
  },
});

export const warningSoftStyles = theme => {
  const isDark = theme.palette.mode === 'dark';
  return {
    backgroundColor: alpha(theme.palette.warning.main, isDark ? 0.22 : 0.16),
    color: isDark ? theme.palette.warning.light : theme.palette.warning.dark,
    border: `1px solid ${alpha(theme.palette.warning.main, isDark ? 0.35 : 0.4)}`,
  };
};

export const primaryTint = (theme, opacity = 0.08) => alpha(theme.palette.primary.main, opacity);
